import React from 'react';
import { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { collection, query, getDocs } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useSettings } from '../lib/hooks/useSettings';

const Footer = () => {
  const { settings } = useSettings();
  const [showNavigator, setShowNavigator] = useState(false);

  useEffect(() => {
    const checkForFloorPlans = async () => {
      try {
        const q = query(collection(db, 'floorPlans'));
        const querySnapshot = await getDocs(q);
        setShowNavigator(querySnapshot.size > 0);
      } catch (error) {
        console.error('Error checking floor plans:', error);
        setShowNavigator(false);
      }
    };

    checkForFloorPlans();
  }, []);

  return (
    <footer className="bg-primary text-white py-16">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            {settings.logoUrl ? (
              <img
                src={settings.logoUrl}
                alt={settings.companyName}
                className="h-12 w-auto object-contain mb-6"
              />
            ) : (
              <h3 className="text-2xl font-sans mb-6">
                <span className="text-secondary">{settings.companyName}</span>
              </h3>
            )}
            <p className="text-neutral-200 mb-6">
              {settings.description}
            </p>
            {(settings.socialMedia?.facebook || settings.socialMedia?.instagram) && (
              <div className="flex space-x-3">
                {settings.socialMedia?.facebook && (
                  <a
                    href={settings.socialMedia.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-secondary hover:text-primary transition-colors"
                  >
                    <Facebook className="h-5 w-5" />
                  </a>
                )}
                {settings.socialMedia?.instagram && (
                  <a
                    href={settings.socialMedia.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-secondary hover:text-primary transition-colors"
                  >
                    <Instagram className="h-5 w-5" />
                  </a>
                )}
              </div>
            )}
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-6">Връзки в сайта</h3>
            <div className="space-y-3">
              <Link to="/" className="block text-neutral-200 hover:text-secondary transition duration-300">
                Начало
              </Link>
              <Link to="/apartments" className="block text-neutral-200 hover:text-secondary transition duration-300">
                {settings.catalogLabel}
              </Link>
              <Link to="/gallery" className="block text-neutral-200 hover:text-secondary transition duration-300">
                Галерия
              </Link>
              {showNavigator && (
                <Link to="/navigator" className="block text-neutral-200 hover:text-secondary transition duration-300">
                  Разпределения
                </Link>
              )}
              <a href="/#contact" className="block text-neutral-200 hover:text-secondary transition duration-300">
                Контакти
              </a>
              <a href="/#location" className="block text-neutral-200 hover:text-secondary transition duration-300">
                Локация
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-6">Контакти</h3>
            <div className="space-y-4">
              <div className="flex items-center">
                <Phone className="h-5 w-5 mr-3" />
                <a
                  href={`tel:${(settings.phone || '').replace(/\s+/g, '')}`}
                  className="hover:text-secondary transition duration-300"
                >
                  {settings.phone}
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 mr-3" />
                <a
                  href={`mailto:${settings.email}`}
                  className="hover:text-secondary transition duration-300"
                >
                  {settings.email}
                </a>
              </div>
              <div className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 mt-1" />
                <span>{settings.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-sm text-neutral-300">
          <p>© {new Date().getFullYear()} {settings.companyName}. Всички права запазени.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;